import { render, staticRenderFns } from "./blood.vue?vue&type=template&id=7487ff34"
import script from "./blood.vue?vue&type=script&lang=js"
export * from "./blood.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports